module.exports = __webpack_public_path__ + "static/media/stamp_4.b54f7c56.png";